<!-- ========== App Menu ========== -->
<div class="app-menu navbar-menu">
  <!-- LOGO -->
  <div class="navbar-brand-box">
    <a routerLink="/" class="logo logo-light">
      <span class="logo-sm">
        <img src="assets/images/unique.png" alt="" height="22">
      </span>
      <span class="logo-lg">
        <img class="w-80" src="assets/images/logo-light-text.png" alt="">
      </span>
    </a>
    <button type="button" class="btn btn-sm p-0 fs-20 header-item float-end btn-vertical-sm-hover" id="vertical-hover"
      (click)="toggleMobileMenu($event)">
      <i class="ri-record-circle-line"></i>
    </button>
  </div>

  <div id="scrollbar">
    <div class="container-fluid">

      <div id="two-column-menu">
      </div>
      <ngx-simplebar class="sidebar-menu-scroll" style="max-height: calc(100vh - 70px)">
        <ul class="metismenu list-unstyled navbar-nav" id="navbar-nav">

          <ng-container *ngFor="let item of menuItems; let i = index">
            <li class="menu-title" *ngIf="item.isTitle"><span data-key="t-menu">{{ item.label }}</span></li>

            <li class="nav-item" *ngIf="!item.isTitle && !item.isLayout">
              <ng-container *ngIf="hasItems(item)">
                <a *ngxPermissionsOnly="item.permissions" id="menu-{{i}}" href="javascript:void(0);"
                  class="is-parent nav-link menu-link"
                  [ngClass]="{'has-arrow': !item.badge, 'has-dropdown': item.badge}" data-bs-toggle="collapse"
                  aria-expanded="false" (click)="toggleItem($event)">
                  <i class="{{ item.icon }} icon nav-icon" class=""></i>
                  <span class=""> {{ item.label }}</span>
                  <span class="badge badge-pill {{item.badge.variant}}" *ngIf="item.badge">{{item.badge.text
                    }}</span>
                </a>
              </ng-container>
              <ng-container *ngIf="!hasItems(item)">
                <a [routerLink]="item.link" *ngxPermissionsOnly="item.permissions"
                  class="side-nav-link-ref nav-link menu-link item-menu-{{i}}" (click)="toggleParentItem($event)">
                  <i class="bx {{ item.icon }} icon nav-icon" *ngIf="item.icon" class=""></i>
                  <span class=""> {{ item.label }}</span>
                  <span class="badge badge-pill {{item.badge.variant}}" *ngIf="item.badge">{{item.badge.text
                    }}</span>
                </a>
              </ng-container>



              <div class="collapse menu-dropdown" *ngIf="hasItems(item)">
                <ul *ngIf="hasItems(item)" class="nav nav-sm flex-column" aria-expanded="false">
                  <li *ngFor="let subitem of item.subItems; let i = index" class="nav-item">
                    <ng-container *ngIf="!hasItems(subitem)">
                      <a [routerLink]="subitem.link" *ngxPermissionsOnly="subitem.permissions"
                        class="nav-link nav-subItems-{{i}}" [attr.data-parent]="subitem.parentId"
                        (click)="updateActive($event,i)">
                        <i class="{{ subitem.icon }} icon nav-icon" class=""></i>
                        <span class=""> {{ subitem.label }}</span>
                        <span class="badge badge-pill {{subitem.badge.variant}}"
                          *ngIf="subitem.badge">{{subitem.badge.text
                          }}</span>
                      </a>
                    </ng-container>
                    <ng-container *ngIf="hasItems(subitem)">
                      <a *ngxPermissionsOnly="subitem.permissions" class="nav-link" href="javascript:void(0);"
                        [attr.data-parent]="subitem.parentId" data-bs-toggle="collapse" aria-expanded="false"
                        (click)="toggleSubItem($event)">
                        {{ subitem.label}}
                        <span class="badge badge-pill {{subitem.badge.variant}}"
                          *ngIf="subitem.badge">{{subitem.badge.text
                          }}</span>
                      </a>
                    </ng-container>


                    <div class="collapse menu-dropdown sub-menu" *ngIf="hasItems(subitem)">
                      <ul *ngIf="hasItems(subitem)" class="nav nav-sm flex-column" aria-expanded="false">
                        <li *ngFor="let subSubitem of subitem.subItems; let i = index" class="nav-item">
                          <ng-container *ngIf="!hasItems(subSubitem)">
                            <a [routerLink]="subSubitem.link" *ngxPermissionsOnly="subSubitem.permissions"
                              class="nav-link nav-subSubItems-{{i}}" [attr.data-parent]="subSubitem.parentId"
                              (click)="updateActive($event,i)">
                              <i class="{{ subSubitem.icon }} icon nav-icon" class=""></i>
                              <span class=""> {{ subSubitem.label }}</span>
                            </a>
                          </ng-container>
                          <ng-container *ngIf="hasItems(subSubitem)">
                            <a *ngxPermissionsOnly="subSubitem.permissions" class="nav-link" href="javascript:void(0);"
                              [attr.data-parent]="subSubitem.parentId" data-bs-toggle="collapse" aria-expanded="false"
                              (click)="toggleExtraSubItem($event)">
                              {{ subSubitem.label}}
                              <span class="badge badge-pill {{subSubitem.badge.variant}}"
                                *ngIf="subSubitem.badge">{{subSubitem.badge.text
                                }}</span>
                            </a>
                          </ng-container>

                          <div class="collapse menu-dropdown extra-sub-menu" *ngIf="hasItems(subSubitem)">
                            <ul *ngIf="hasItems(subSubitem)" class="nav nav-sm flex-column" aria-expanded="false">
                              <li *ngFor="let subSubitem1 of subSubitem.subItems; let i = index" class="nav-item">
                                <ng-container>
                                  <a [attr.data-parent]="subSubitem1.parentId"
                                    *ngxPermissionsOnly="subSubitem1.permissions" [routerLink]="subSubitem1.link"
                                    class="nav-link nav-sub1SubItems-{{i}}" (click)=" updateActive($event,i)">
                                    <i class="{{ subSubitem1.icon }} icon nav-icon" class=""></i>
                                    <span class=""> {{ subSubitem1.label }}</span>
                                  </a>
                                </ng-container>


                              </li>
                            </ul>
                          </div>

                        </li>
                      </ul>
                    </div>
                  </li>
                </ul>
              </div>
            </li>
          </ng-container>
        </ul>
      </ngx-simplebar>
    </div>
    <!-- Sidebar -->
  </div>
  <div class="sidebar-background"></div>
</div>
<!-- Left Sidebar End -->
<!-- Vertical Overlay-->
<div class="vertical-overlay" (click)="SidebarHide()"></div>